import { Outlet, Route } from "react-router-dom"
import { RouteConfig } from "~/routes"
import { useMe } from "~/api2/hooks/useMe"
import { Navigate } from "react-router-dom"
import eAdminUserRole from "~/enums/eAdminUserRole"
import { ROUTER_PATHS } from "~/routes/constants"

interface RoleBasedRouteProps {
  route: RouteConfig
  children?: React.ReactNode
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ route, children }) => {
  const { data: user } = useMe()

  // If no roles are required, render the route normally
  if (!route.roles || route.roles.length === 0) {
    return <>{children}</>
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />
  }

  // Check if user has any of the required roles
  const userRoles = user.roles || []
  const hasRequiredRole = route.roles.some(requiredRole =>
    userRoles.includes(requiredRole as eAdminUserRole)
  )

  // Redirect to unauthorized page
  if (!hasRequiredRole) {
    return <Navigate to={ROUTER_PATHS.UNAUTHORIZED} replace />
  }

  return <>{children}</>
}

export const renderRoutes = (routes: RouteConfig[]): JSX.Element[] => {
  return routes.map((route, index) => {
    if (route.routes && route.routes.length > 0) {
      const element = route.layout ? route.layout : <Outlet />
      return (
        <Route key={index} path={route.path} element={
          <RoleBasedRoute route={route}>
            {element}
          </RoleBasedRoute>
        }>
          {renderRoutes(route.routes)}
        </Route>
      )
    }

    return (
      <Route
        key={index}
        path={route.path}
        element={
          <RoleBasedRoute route={route}>
            {route.component}
          </RoleBasedRoute>
        }
      />
    )
  })
}
